<template lang="pug">
.profile
    loader(:showLoader="show")
    .container.mx-auto.text-left
        .bg-blue-lightest.border-t.border-b.border-blue.text-blue-dark.px-4.py-3.mb-4(role='alert' v-if="showAlert")
            p.font-bold 🙌 Success
            p.text-sm Thanks for reaching out. We've recieved your message and will get back to you shortly!
        p.text-lg.text-white Shoot me a message:
        .mt-4
            label.settings-input-label Name
            input.settings-input(v-model='message.name', type="name" placeholder='Name')
        .mt-4
            label.settings-input-label Email
            input.settings-input(v-model='message.email', type="email" placeholder='Email')
        .mt-4
            label.settings-input-label Message
            textarea.settings-input(v-model='message.msg', rows="6", placeholder='Please be nice, I\'m human! :)')
        .mt-4
            button.btn.btn-primary.btn-sm(@click="sendMsg") Send
</template>

<script>
import axios from 'axios'
import Loader from '@/components/modules/Loader'

export default {
  name: 'Contact',
  components: {
    Loader,
    axios
  },
  data () {
    return {
      show: false,
      showAlert: false,
      message: {
        name: '',
        email: '',
        msg: ''
      },
      user: {

      }
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.message.name = this.user.name
    this.message.email = this.user.email
  },
  methods: {
    sendMsg () {
      if (this.message.name === '' || this.message.email === '' || this.message.msg === '') {
        alert('Please fill in the fields')
        return
      }
      console.log(this.message)
      this.show = true
      axios.post(`user/message`, this.message).then((user) => {
        console.log(user)
        this.show = false
        this.showAlert = true
        setTimeout(function () {
          console.log('timeout')
          this.showAlert = false
        }.bind(this), 4000)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue